// create a container and set the full-size image as its background
// function createOverlay(image) {
//   const overlayImage = document.createElement('img');
//   overlayImage.setAttribute('src', `${image.src}`);
//   overlay = document.createElement('div');
//   prepareOverlay(overlay, overlayImage);

//   image.style.opacity = '50%';
//   toggleLoadingSpinner(image);

//   overlayImage.onload = () => {
//     toggleLoadingSpinner(image);
//     image.parentElement.insertBefore(overlay, image);
//     image.style.opacity = '100%';
//   };

//   return overlay;
// }

// function prepareOverlay(container, image) {
//   container.setAttribute('class', 'image-magnify-full-size');
//   container.setAttribute('aria-hidden', 'true');
//   container.style.backgroundImage = `url('${image.src}')`;
//   container.style.backgroundColor = 'var(--gradient-background)';
// }

// function toggleLoadingSpinner(image) {
//   const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
//   loadingSpinner.classList.toggle('hidden');
// }

// function moveWithHover(image, event, zoomRatio) {
//   // calculate mouse position
//   const ratio = image.height / image.width;
//   const container = event.target.getBoundingClientRect();
//   const xPosition = event.clientX - container.left;
//   const yPosition = event.clientY - container.top;
//   const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
//   const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

//   // determine what to show in the frame
//   overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
//   overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
// }

// function magnify(image, zoomRatio) {
//   const overlay = createOverlay(image);
//   overlay.onclick = () => overlay.remove();
//   overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
//   overlay.onmouseleave = () => overlay.remove();
// }

// function enableZoomOnHover(zoomRatio) {
//   const images = document.querySelectorAll('.image-magnify-hover');
//   images.forEach((image) => {
//     image.onclick = (event) => {
//       magnify(image, zoomRatio);
//       moveWithHover(image, event, zoomRatio);
//     };
//   });
// }

// enableZoomOnHover(2);

/* ======================================================
   SHOPIFY RISE THEME – HOVER MAGNIFY SCRIPT (FINAL + FIXED)
   - No click required
   - No blinking or flicker
   - Smooth Amazon-style magnify
   - Overlay uses pointer-events: none (critical fix)
====================================================== */

// 1️⃣ Create overlay container placed above the original image
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', image.src);

  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  // Fade original while loading
  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.style.position = "relative"; // ensure stacking
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

// 2️⃣ Prepare the overlay background and styles
function prepareOverlay(container, image) {
  container.className = 'image-magnify-full-size';
  container.setAttribute('aria-hidden', 'true');

  // Visual background
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundRepeat = 'no-repeat';
  container.style.backgroundColor = 'var(--gradient-background)';

  // FIX: prevent flicker by never letting overlay receive mouse events
  container.style.pointerEvents = 'none';

  // Position overlay
  container.style.position = 'absolute';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '100%';
  container.style.height = '100%';
  container.style.zIndex = '5';

  // Cursor invisible (Amazon style)
  container.style.cursor = 'none';
}

// 3️⃣ Show or hide the loading spinner when zoom loads
function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector('.loading__spinner');
  if (loadingSpinner) {
    loadingSpinner.classList.toggle('hidden');
  }
}

// 4️⃣ Move zoom window with mouse hover
function moveWithHover(image, event, zoomRatio) {
  const overlay = image.parentElement.querySelector('.image-magnify-full-size');
  if (!overlay) return;

  const rect = image.getBoundingClientRect();

  const xPos = event.clientX - rect.left;
  const yPos = event.clientY - rect.top;

  const xPercent = `${(xPos / image.clientWidth) * 100}%`;
  const yPercent = `${(yPos / image.clientHeight) * 100}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

// 5️⃣ Create magnifier overlay & assign events
function magnify(image, zoomRatio) {
  const overlayEl = createOverlay(image);

  // All movement handled by the ORIGINAL IMAGE (not overlay)
  image.addEventListener('mousemove', (event) => {
    moveWithHover(image, event, zoomRatio);
  });

  // Clean up
  image.addEventListener('mouseleave', () => {
    const overlay = image.parentElement.querySelector('.image-magnify-full-size');
    if (overlay) overlay.remove();
  });

  return overlayEl;
}

// 6️⃣ Enable zoom on ANY image with class "image-magnify-hover"
function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    let overlayEl = null;

    image.addEventListener('mouseenter', () => {
      if (!overlayEl) overlayEl = magnify(image, zoomRatio);
    });

    image.addEventListener('mouseleave', () => {
      const overlay = image.parentElement.querySelector('.image-magnify-full-size');
      if (overlay) overlay.remove();
      overlayEl = null;
    });
  });
}

// 7️⃣ Activate magnify at 2x zoom by default
enableZoomOnHover(2);
